import { get } from "../../service/api";

const GetMerchants = async () => {
    try {
        const response = await get(`/admin/merchant/dropdown`);
        return response;
    } catch (error) {
        console.error('Error GetMerchants:', error);
        throw error;
    }
};

export default GetMerchants;